module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item active text-capitalize"
  }, [_vm._v(_vm._s(_vm.currentPage))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t('team.labels.createTeam')))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("team.title")))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('team')
    }
  }, [_c('label', {
    attrs: {
      "for": "team"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('span', {
    staticClass: "guideline-block"
  }, [_vm._v(_vm._s(_vm.$t('team.displayName.textGuide')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.team),
      expression: "user.team"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "team",
      "placeholder": _vm.$t('team.displayName.labels')
    },
    domProps: {
      "value": _vm._s(_vm.user.team)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.team = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('namespace')
    }
  }, [_c('label', {
    attrs: {
      "for": "namespace"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')))]), _vm._v(" "), _c('span', {
    staticClass: "help-block m-t-0"
  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.namespace),
      expression: "user.namespace"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "namespace",
      "placeholder": _vm.$t('team.url.labels')
    },
    domProps: {
      "value": _vm._s(_vm.user.namespace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.namespace = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.showTeamType) ? _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('type')
    }
  }, [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.type.labels')))]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.type),
      expression: "user.type"
    }],
    attrs: {
      "type": "radio",
      "value": "normal-team"
    },
    domProps: {
      "checked": _vm._q(_vm.user.type, "normal-team")
    },
    on: {
      "click": function($event) {
        _vm.user.type = "normal-team"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputRadiosUnchecked"
    }
  }, [_vm._v("Normal Team")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.type),
      expression: "user.type"
    }],
    attrs: {
      "type": "radio",
      "value": "reseller"
    },
    domProps: {
      "checked": _vm._q(_vm.user.type, "reseller")
    },
    on: {
      "click": function($event) {
        _vm.user.type = "reseller"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputRadiosUnchecked"
    }
  }, [_vm._v("Reseller")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.type),
      expression: "user.type"
    }],
    attrs: {
      "type": "radio",
      "value": "sub-team"
    },
    domProps: {
      "checked": _vm._q(_vm.user.type, "sub-team")
    },
    on: {
      "click": function($event) {
        _vm.user.type = "sub-team"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputRadiosUnchecked"
    }
  }, [_vm._v("Sub Team of Reseller")])])]) : _vm._e(), _vm._v(" "), (_vm.user.type === 'sub-team' && _vm.showTeamType) ? _c('form-group', [_c('label', {
    attrs: {
      "for": "team"
    }
  }, [_vm._v("Choose Reseller "), _c('span', {
    staticClass: "red-600"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentResellerTeam),
      expression: "currentResellerTeam"
    }],
    attrs: {
      "options": _vm.filterItems
    },
    domProps: {
      "value": (_vm.currentResellerTeam)
    },
    on: {
      "input": function($event) {
        _vm.currentResellerTeam = $event
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('account.labels.account')))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('displayname'),
      "autocomplete": "false"
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.displayName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.displayname),
      expression: "user.displayname"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('account.labels.displayName')
    },
    domProps: {
      "value": _vm._s(_vm.user.displayname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.displayname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('account.labels.email'),
      "autocomplete": "false"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('account.labels.password')
    },
    domProps: {
      "value": _vm._s(_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" Submit\n              ")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e659633!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/teams/TeamCreator.vue
// module id = 512
// module chunks = 1